module.exports = __webpack_public_path__ + "static/media/dots-menu-horizontal.9af1a2db.svg";